var staticEscapeMap = require('./staticEscapeMap')

var helperFormatEscaper = require('./helperFormatEscaper')

var each = require('./each')

var unescapeMap = {}
each(staticEscapeMap, function (item, key) {
  unescapeMap[staticEscapeMap[key]] = key
})

/**
  * 反转escape
  *
  * @param {String} str 字符串
  * @return {String}
  */
var unescape = helperFormatEscaper(unescapeMap)

module.exports = unescape



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/unescape.js
// module id = 1093
// module chunks = 75